module.exports = __webpack_public_path__ + "static/media/pics15.66d954d9.png";